module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_4_sub1-c1a00b9fde053fae5160aa31ce9f5908.png";